<template>
    <v-select
        :append-icon="selectedNarrative ? null : 'expand_more'"
        class="narrative-selector"
        :color="selectedNarrative"
        dense
        filled
        height="40"
        hide-details
        hide-no-data
        :items="narratives"
        item-text="mobileDisplay"
        item-value="name"
        label="Narrative"
        :menu-props="{ offsetY: true }"
        outlined
        rounded
        single-line
        v-model="selectedNarrative">
    </v-select>
</template>

<script>
    import { narrativeStats } from "../../constants/narrativeStats";

    export default {
        name: "narrative-selector",
        data() {
            return {
                narrativeStats: narrativeStats,
            }
        },
        computed: {
            selectedNarrative: {
                get(){
                   return this.$route.name;
                },
                set(narrative){
                    if(narrative){
                        this.$router.push({
                            name: narrative
                        });
                    } else {
                        this.$router.push({
                            name: 'all'
                        })
                    }
                },
            },
            narratives(){
                return Object.values(this.narrativeStats);
            }
        }
    }
</script>

<style lang="scss">
    .narrative-selector{
        .v-input__icon--clear{
            opacity: 1;
        }

        .v-input__slot{
            padding: 0 16px!important;
        }
    }

</style>